

const MTYearNumber = [
  { quizNo: '1', type: 'pyq', year: 26, month: '01', day: 21, shift: 1 },
  { quizNo: '2', type: 'pyq', year: 26, month: '01', day: 21, shift: 2 },
  { quizNo: '3', type: 'pyq', year: 26, month: '01', day: 22, shift: 1 },
  { quizNo: '4', type: 'pyq', year: 26, month: '01', day: 22, shift: 2 },
  { quizNo: '5', type: 'pyq', year: 26, month: '01', day: 23, shift: 1 },
  { quizNo: '6', type: 'pyq', year: 26, month: '01', day: 23, shift: 2 },
  { quizNo: '7', type: 'pyq', year: 26, month: '01', day: 24, shift: 1 },
  { quizNo: '8', type: 'pyq', year: 26, month: '01', day: 24, shift: 2 },
  { quizNo: '9', type: 'pyq', year: 26, month: '01', day: 28, shift: 1 },
  { quizNo: '10', type: 'pyq', year: 26, month: '01', day: 28, shift: 2 },
  { quizNo: '11', type: 'pyq', year: 26, month: '04', day: '02', shift: 1 },
  { quizNo: '12', type: 'pyq', year: 26, month: '04', day: '02', shift: 2 },
  { quizNo: '13', type: 'pyq', year: 26, month: '04', day: '04', shift: 1 },
  { quizNo: '14', type: 'pyq', year: 26, month: '04', day: '04', shift: 2 },
  { quizNo: '15', type: 'pyq', year: 26, month: '04', day: '05', shift: 1 },
  { quizNo: '16', type: 'pyq', year: 26, month: '04', day: '05', shift: 2 },
  { quizNo: '17', type: 'pyq', year: 26, month: '04', day: '06', shift: 1 },
  { quizNo: '18', type: 'pyq', year: 26, month: '04', day: '06', shift: 2 },
  { quizNo: '19', type: 'pyq', year: 26, month: '04', day: '08', shift: 2 },



];

export default MTYearNumber;

